<template>
  <div class="UserConnections">

    <user-breadcrumbs :items="[{text: 'Teams'}]">
    </user-breadcrumbs>

    <user-toolbar :user="user">
    </user-toolbar>

    <teams-table :teams="filteredTeams"
                 :user="user"
                 :loading="busy"
                 @updated="$emit('updated')"
                 class="mb-4">
    </teams-table>

    <add-user-to-team :user="user"
                      @updated="$emit('updated')">
    </add-user-to-team>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import UserBreadcrumbs from './components/UserBreadcrumbs';
import UserToolbar from './components/UserToolbar';
import userService from '../../services/userService';
import oauthService from "../../../../ml/services/oauthService";
import ConnectionsTable from "../user/components/ConnectionsTable";
import {orderBy} from 'lodash';
import TeamsTable from "../user/components/TeamsTable";
import AddUserToTeam from '../user/components/AddUserToTeam';

export default {
  components: {AddUserToTeam, TeamsTable, ConnectionsTable, UserToolbar, UserBreadcrumbs},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', 'Teams');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Users', exact: true, to: {name: 'users'},},
        {text: 'Show User'}
      ],
      busy: false,
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    filteredTeams() {
      return orderBy(this.user.teams, ['status', 'name'], ['asc', 'asc'])
    }
  },
}
</script>
